import { ViewType } from 'types/graphql'

import { parseViewUuidFromSearch } from './parseViewUuidFromSearch'

export const shouldApplyViewUuidFromUrl = (viewType: ViewType): boolean =>
  viewType === 'RecordsForStaffInModule' ||
  viewType === 'RecordTaskInspectionAttemptsForStaffInModule'

export const parseViewUuidFromSearchForViewType = (
  search: string,
  viewType: ViewType
): string | null => {
  if (!shouldApplyViewUuidFromUrl(viewType)) {
    return null
  }
  return parseViewUuidFromSearch(search)
}
